export default "__VITE_ASSET__CxWHY_1i__"